<!-- Authenticated in-app route: /wisdom-care (see Org.vue "Wisdom Care" card, router.js). -->
<template>
    <div class="section text-center" v-if="loading">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <template v-else>
        <div class="section mt-2" v-if="successMessage || errorMessage">
            <div class="alert alert-success" v-if="successMessage">{{ successMessage }}</div>
            <div class="alert alert-danger" v-if="errorMessage">{{ errorMessage }}</div>
        </div>

        <!-- NOT YET REGISTERED -->
        <div class="section pt-0 mt-1 pb-2" v-if="!profile">
            <!-- CONSENT GATE -->
            <template v-if="!consentGiven">
                <div class="card">
                    <div class="card-body text-center">
                        <div class="wc-hero-logo mb-3">
                            <img src="https://guideportal.wisdomislam.org/uploads/image/1786517974.png" alt="Wisdom Care" />
                        </div>
                        <p class="mal-text mb-3">Wisdom Care വളണ്ടിയർ ആയി സേവനം ചെയ്യാൻ താങ്കൾ തയ്യാറാണോ?</p>
                        <button type="button" class="btn btn-primary btn-block mal-text mb-2" @click="consentGiven = true">അതെ (Yes)</button>
                        <button type="button" class="btn btn-outline-secondary btn-block mal-text" @click="$router.push('/org')">ഇല്ല (No)</button>
                    </div>
                </div>
            </template>

            <template v-else>
                <div class="listed-detail mt-1 mb-2">
                    <p class="mal-text text-muted text-center">
                        'വിസ്ഡം കെയർ' വളണ്ടിയറായി രജിസ്റ്റർ ചെയ്യുക.
                    </p>
                </div>
                <div class="card">
                    <div class="card-body">
                        <Form @submit="submitRegister" :validation-schema="registerSchema">
                            <!-- DYNAMIC QUESTIONNAIRE -->
                            <template v-for="(qs, section) in questionsBySection" :key="'sec_' + section">
                                <div class="listed-detail mt-1 mb-1">
                                    <h4 class="mal-text">{{ section }}</h4>
                                </div>
                                <div class="form-group basic" v-for="q in qs" :key="'q_' + q.id">
                                    <div class="input-wrapper">
                                        <label class="label mal-text text-primary">{{ questionLabel(q) }}<span v-if="q.required" class="text-danger"> *</span></label>

                                        <input v-if="q.type === 'short_text'" type="text" class="form-control" v-model="answerFormData[q.id].answer_text" />

                                        <template v-else-if="q.type === 'single_choice'">
                                            <div class="form-check mb-1" v-for="opt in q.options" :key="'q_' + q.id + '_' + opt.mal">
                                                <input type="radio" class="form-check-input" :id="'q_' + q.id + '_' + opt.mal" :name="'q_' + q.id" :value="opt.mal" v-model="answerFormData[q.id].answer_text" />
                                                <label class="form-check-label mal-text" :for="'q_' + q.id + '_' + opt.mal">{{ optionLabel(opt) }}</label>
                                            </div>
                                            <div class="form-check mb-1" v-if="q.allow_other">
                                                <input type="radio" class="form-check-input" :id="'q_' + q.id + '_other'" :name="'q_' + q.id" value="__other__" v-model="answerFormData[q.id].answer_text" />
                                                <label class="form-check-label mal-text" :for="'q_' + q.id + '_other'">{{ otherLabel() }}</label>
                                                <input v-if="answerFormData[q.id].answer_text === '__other__'" type="text" class="form-control mt-1" placeholder="വിശദമാക്കുക" v-model="answerFormData[q.id].other_text" />
                                            </div>
                                        </template>

                                        <template v-else-if="q.type === 'checkboxes'">
                                            <div class="form-check mb-1" v-for="opt in q.options" :key="'q_' + q.id + '_' + opt.mal">
                                                <input type="checkbox" class="form-check-input" :id="'q_' + q.id + '_' + opt.mal" :value="opt.mal" v-model="answerFormData[q.id].answer_options" />
                                                <label class="form-check-label mal-text" :for="'q_' + q.id + '_' + opt.mal">{{ optionLabel(opt) }}</label>
                                            </div>
                                            <div class="form-check mb-1" v-if="q.allow_other">
                                                <input type="checkbox" class="form-check-input" :id="'q_' + q.id + '_other'" value="__other__" v-model="answerFormData[q.id].answer_options" />
                                                <label class="form-check-label mal-text" :for="'q_' + q.id + '_other'">{{ otherLabel() }}</label>
                                                <input v-if="answerFormData[q.id].answer_options.includes('__other__')" type="text" class="form-control mt-1" placeholder="വിശദമാക്കുക" v-model="answerFormData[q.id].other_text" />
                                            </div>
                                        </template>
                                    </div>
                                </div>

                                <template v-if="section === firstQuestionSection">
                                    <div class="form-group basic">
                                        <div class="input-wrapper">
                                            <label class="label mal-text text-primary"><ion-icon name="male-female-outline" class="wc-label-icon"></ion-icon>ലിംഗം (Gender)</label>
                                            <Field as="select" name="gender" class="form-control" v-model="registerFormData.gender">
                                                <option value="">Select Gender</option>
                                                <option value="male">Male</option>
                                                <option value="female">Female</option>
                                            </Field>
                                            <ErrorMessage name="gender" class="error-feedback" />
                                        </div>
                                    </div>
                                    <div class="form-group basic">
                                        <div class="input-wrapper">
                                            <label class="label mal-text text-primary"><ion-icon name="calendar-outline" class="wc-label-icon"></ion-icon>ജനന തീയതി (DOB)</label>
                                            <Field type="date" name="dob" class="form-control" v-model="registerFormData.dob" />
                                            <ErrorMessage name="dob" class="error-feedback" />
                                        </div>
                                    </div>
                                    <div class="form-group basic">
                                        <div class="input-wrapper">
                                            <label class="label mal-text text-primary"><ion-icon name="mail-outline" class="wc-label-icon"></ion-icon>ഇമെയിൽ (Email)</label>
                                            <Field type="email" name="email" class="form-control" v-model="registerFormData.email" />
                                            <ErrorMessage name="email" class="error-feedback" />
                                        </div>
                                    </div>
                                    <div class="form-group basic">
                                        <div class="input-wrapper">
                                            <label class="label mal-text text-primary"><ion-icon name="home-outline" class="wc-label-icon"></ion-icon>വിലാസം (Address)</label>
                                            <Field as="textarea" name="address" class="form-control" rows="2" v-model="registerFormData.address" />
                                            <ErrorMessage name="address" class="error-feedback" />
                                        </div>
                                    </div>
                                </template>
                            </template>

                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label mal-text text-primary">എനിക്ക് താഴെപ്പറയുന്ന മേഖലകളിൽ കുഴപ്പമില്ലാത്ത കഴിവ്/അനുഭവങ്ങൾ ഉണ്ട്</label>
                                    <div class="form-check mb-1 col-12" v-for="c in serviceCategories" :key="c.id">
                                        <input type="checkbox" class="form-check-input" :id="'sc_' + c.id" :value="c.id" v-model="registerFormData.service_category_ids" />
                                        <label class="form-check-label mal-text" :for="'sc_' + c.id">{{ c.name }}<template v-if="c.name_mal"> ({{ c.name_mal }})</template></label>
                                    </div>
                                </div>
                            </div>

                            <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="registering">
                                <span v-show="registering" class="spinner-border spinner-border-sm"></span>
                                <span class="mal-text">രജിസ്റ്റർ ചെയ്യുക (Register)</span>
                            </button>
                        </Form>
                    </div>
                </div>
            </template>
        </div>

        <!-- PROFILE VIEW -->
        <template v-else-if="!editingProfile">
            <transition name="wc-success-pop">
                <div class="section mt-2" v-if="justRegistered">
                    <div class="wc-success-card">
                        <div class="wc-success-icon"><ion-icon name="checkmark-circle"></ion-icon></div>
                        <h4 class="mal-text">രജിസ്ട്രേഷൻ വിജയകരമായി പൂർത്തിയായി!</h4>
                        <p class="mal-text">Wisdom Care വളണ്ടിയർ ആയി ചേർന്നതിന് നന്ദി.</p>
                    </div>
                </div>
            </transition>

            <div class="section mt-2">
                <div class="wc-card wc-card-blue wc-profile-card">
                    <div class="wc-profile-header">
                        <div class="wc-avatar-icon">
                            <img v-if="memberDefaults.avatar" :src="'https://guide.msoftit.com/' + memberDefaults.avatar" alt="avatar" />
                            <ion-icon v-else name="person-outline"></ion-icon>
                        </div>
                        <div class="wc-profile-info">
                            <h3 class="mal-text">{{ profile.name }}</h3>
                            <span class="basic-inline"><ion-icon name="call-outline" class="basic-inline-icon"></ion-icon><span class="basic-inline-text">{{ profile.mobile }}</span></span>
                            <span class="wc-status-pill" :class="profile.verified ? 'verified' : 'not-verified'">
                                <ion-icon :name="profile.verified ? 'checkmark-circle' : 'close-circle'"></ion-icon>
                                {{ profile.verified ? 'Verified' : 'Not Verified' }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section mt-2">
                <div class="wc-card wc-card-neutral">
                    <div class="basic-inline-grid">
                        <div class="form-group-compact basic-inline" v-if="profile.gender">
                            <ion-icon name="male-female-outline" class="basic-inline-icon"></ion-icon>
                            <span class="basic-inline-text text-capitalize">{{ profile.gender }}</span>
                        </div>
                        <div class="form-group-compact basic-inline" v-if="profile.dob">
                            <ion-icon name="calendar-outline" class="basic-inline-icon"></ion-icon>
                            <span class="basic-inline-text">{{ profile.dob }}</span>
                        </div>
                        <div class="form-group-compact basic-inline basic-inline-full" v-if="profile.email">
                            <ion-icon name="mail-outline" class="basic-inline-icon"></ion-icon>
                            <span class="basic-inline-text">{{ profile.email }}</span>
                        </div>
                        <div class="form-group-compact basic-inline basic-inline-full" v-if="profile.address">
                            <ion-icon name="home-outline" class="basic-inline-icon"></ion-icon>
                            <span class="basic-inline-text">{{ profile.address }}</span>
                        </div>
                        <div class="form-group-compact basic-inline basic-inline-full">
                            <ion-icon name="location-outline" class="basic-inline-icon"></ion-icon>
                            <span class="basic-inline-text">{{ profile.district_name }} / {{ profile.zone_name }} / {{ profile.unit_name }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- VERIFIED SKILL BADGES (admin-awarded — read-only for the volunteer). Placed right
                 after the details card, before every other section — each badge as its own list
                 row (icon + name + subtitle) rather than a medal grid, so it stays readable and
                 compact whether there's one badge or several. -->
            <div class="section mt-3" v-if="profile.badges && profile.badges.length">
                <div class="wc-section-title">
                    <span class="wc-icon-circle amber"><ion-icon name="ribbon-outline"></ion-icon></span>
                    <span class="mal-text">വെരിഫൈഡ് സ്കിൽ ബാഡ്ജുകൾ (Verified Skill Badges)</span>
                </div>
                <div class="wc-card wc-card-amber wc-badge-list-card">
                    <div class="wc-badge-list-item" v-for="b in profile.badges" :key="'badge' + b.id">
                        <div class="wc-badge-list-icon" :style="badgeMedalStyle(b)">
                            <span v-if="b.icon">{{ b.icon }}</span>
                            <ion-icon v-else name="ribbon"></ion-icon>
                        </div>
                        <div class="wc-badge-list-info">
                            <div class="wc-badge-list-name">{{ b.name }}</div>
                            <div class="wc-badge-list-sub mal-text" v-if="b.name_mal">{{ b.name_mal }}</div>
                            <div class="wc-badge-list-date" v-if="b.awarded_at">{{ b.awarded_at }}</div>
                        </div>
                        <ion-icon name="chevron-forward-outline" class="wc-badge-list-chevron"></ion-icon>
                    </div>
                </div>
            </div>

            <!-- EQUIPMENT & ASSET ISSUED (office-administered — read-only for the volunteer).
                 Placed right after Badges, before every other section — matches the "Equipment &
                 Asset Tracking" requirement's own naming. -->
            <div class="section mt-3" v-if="profile.equipment && profile.equipment.length">
                <div class="wc-section-title">
                    <span class="wc-icon-circle orange"><ion-icon name="cube-outline"></ion-icon></span>
                    <span class="mal-text">എനിക്ക് ലഭിച്ച ഉപകരണങ്ങൾ (Equipment &amp; Asset Issued)</span>
                </div>
                <div class="wc-card wc-card-orange">
                    <div class="transactions">
                        <div class="item" v-for="e in profile.equipment" :key="'eq' + e.id">
                            <div class="detail">
                                <div>
                                    <strong>{{ e.equipment_type_name }}<span v-if="e.quantity > 1"> × {{ e.quantity }}</span></strong>
                                    <p>
                                        <span class="badge" :class="e.status === 'issued' ? 'bg-primary' : (e.status === 'returned' ? 'bg-success' : 'bg-danger')">{{ e.status }}</span>
                                        <span v-if="e.distributed_at"> · {{ e.distributed_at }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section mt-3">
                <div class="wc-section-title">
                    <span class="wc-icon-circle purple"><ion-icon name="star-outline"></ion-icon></span>
                    <span class="mal-text">എനിക്ക് താഴെപ്പറയുന്ന മേഖലകളിൽ കുഴപ്പമില്ലാത്ത കഴിവ്/അനുഭവങ്ങൾ ഉണ്ട്</span>
                </div>
                <div class="wc-card wc-card-purple">
                    <template v-if="profile.service_categories.length || profile.custom_skills.length">
                        <span class="wc-chip mal-text" v-for="c in profile.service_categories" :key="c.id">{{ c.name }}</span>
                        <span class="wc-chip mal-text wc-chip-removable" v-for="(s, idx) in profile.custom_skills" :key="'cs' + idx">
                            {{ s }}
                            <button type="button" class="wc-chip-remove" :disabled="removingSkill === s" @click="removeCustomSkill(s)" aria-label="നീക്കം ചെയ്യുക">×</button>
                        </span>
                    </template>
                    <p class="text-muted text-center mb-0" v-else>ഒന്നും തിരഞ്ഞെടുത്തിട്ടില്ല</p>

                    <div class="wc-card-divider" v-if="!showAddSkill">
                        <button type="button" class="btn btn-outline-primary btn-block wc-btn-icon mal-text" @click="showAddSkill = true">
                            <ion-icon name="add-circle-outline"></ion-icon>
                            <span>ചേർക്കുക (Add)</span>
                        </button>
                    </div>
                    <div class="wc-card-divider" v-else>
                        <div class="form-group basic" v-if="availableServiceCategories.length">
                            <div class="input-wrapper">
                                <label class="label mal-text text-primary">ലിസ്റ്റിൽ നിന്ന് തിരഞ്ഞെടുക്കുക</label>
                                <div class="form-check mb-1 col-12" v-for="c in availableServiceCategories" :key="c.id">
                                    <input type="checkbox" class="form-check-input" :id="'add_sc_' + c.id" :value="c.id" v-model="selectedNewCategoryIds" />
                                    <label class="form-check-label mal-text" :for="'add_sc_' + c.id">{{ c.name }}<template v-if="c.name_mal"> ({{ c.name_mal }})</template></label>
                                </div>
                            </div>
                        </div>
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="label mal-text text-primary">വേറെ മേഖല ടൈപ്പ് ചെയ്യുക</label>
                                <input type="text" class="form-control" v-model="newCustomSkillText" />
                            </div>
                        </div>
                        <button type="button" class="btn btn-primary btn-block mt-2" :disabled="savingSkill || (!newCustomSkillText.trim() && !selectedNewCategoryIds.length)" @click="submitAddCustomSkill">
                            <span v-show="savingSkill" class="spinner-border spinner-border-sm"></span>
                            <span class="mal-text">ചേർക്കുക (Add)</span>
                        </button>
                        <button type="button" class="btn btn-block btn-outline-secondary mt-2 wc-btn-icon mal-text" @click="showAddSkill = false">
                            <ion-icon name="arrow-back-outline"></ion-icon>
                            <span>ബാക്ക് (Back)</span>
                        </button>
                    </div>
                </div>
            </div>

            <!-- PARTICIPATED PROGRAMS (self-add own rows; office-added rows are read-only) -->
            <div class="section mt-3">
                <div class="wc-section-title">
                    <span class="wc-icon-circle green"><ion-icon name="flag-outline"></ion-icon></span>
                    <span class="mal-text">പങ്കെടുത്ത സേവനങ്ങൾ (Participated Programs)</span>
                </div>
                <div class="wc-card wc-card-green">
                    <div class="transactions" v-if="profile.deployments.length">
                        <div class="item" v-for="d in profile.deployments" :key="'dep' + d.id">
                            <div class="detail">
                                <div>
                                    <strong>{{ d.title }}</strong>
                                    <p>{{ d.date_from }}<span v-if="d.date_to && d.date_to !== d.date_from"> — {{ d.date_to }}</span><span v-if="d.location"> · {{ d.location }}</span></p>
                                </div>
                            </div>
                            <button v-if="d.source === 'self'" type="button" class="btn btn-outline-danger btn-sm" @click="deleteDeployment(d.id)">
                                <ion-icon name="trash-outline"></ion-icon>
                            </button>
                        </div>
                    </div>
                    <p class="text-muted text-center mb-0" v-else>ഇതുവരെ ഒന്നും ചേർത്തിട്ടില്ല</p>

                    <div class="wc-card-divider" v-if="!showAddDeployment">
                        <button type="button" class="btn btn-outline-primary btn-block wc-btn-icon mal-text" @click="showAddDeployment = true">
                            <ion-icon name="add-circle-outline"></ion-icon>
                            <span>സേവനം ചേർക്കുക</span>
                        </button>
                    </div>
                    <div class="wc-card-divider" v-else>
                        <Form @submit="submitDeployment" :validation-schema="deploymentSchema">
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label mal-text text-primary">പേര് <span class="text-danger">*</span></label>
                                    <Field type="text" name="title" class="form-control" v-model="newDeployment.title" />
                                    <ErrorMessage name="title" class="error-feedback" />
                                </div>
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label mal-text text-primary">തീയതി <span class="text-danger">*</span></label>
                                    <Field type="date" name="date_from" class="form-control" v-model="newDeployment.date_from" />
                                    <ErrorMessage name="date_from" class="error-feedback" />
                                </div>
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label mal-text text-primary">അവസാന തീയതി</label>
                                    <Field type="date" name="date_to" class="form-control" v-model="newDeployment.date_to" />
                                </div>
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label mal-text text-primary">സ്ഥലം</label>
                                    <Field type="text" name="location" class="form-control" v-model="newDeployment.location" />
                                </div>
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label mal-text text-primary">വിവരണം</label>
                                    <Field as="textarea" name="description" class="form-control" rows="2" v-model="newDeployment.description" />
                                </div>
                            </div>
                            <button type="submit" class="btn btn-primary btn-block" :disabled="savingDeployment">
                                <span v-show="savingDeployment" class="spinner-border spinner-border-sm"></span>
                                <span class="mal-text">ചേർക്കുക (Add)</span>
                            </button>
                            <button type="button" class="btn btn-block btn-outline-secondary mt-2 wc-btn-icon mal-text" @click="showAddDeployment = false">
                                <ion-icon name="arrow-back-outline"></ion-icon>
                                <span>ബാക്ക് (Back)</span>
                            </button>
                        </Form>
                    </div>
                </div>
            </div>

            <!-- ORG TRAININGS (office-administered — read-only for the volunteer) -->
            <div class="section mt-3">
                <div class="wc-section-title">
                    <span class="wc-icon-circle teal"><ion-icon name="school-outline"></ion-icon></span>
                    <span class="mal-text">സംഘടനാ ട്രെയിനിംഗുകൾ (Organizational Trainings)</span>
                </div>
                <div class="wc-card wc-card-teal">
                    <div class="transactions" v-if="profile.org_trainings.length">
                        <div class="item" v-for="t in profile.org_trainings" :key="'ot' + t.id">
                            <div class="detail">
                                <div>
                                    <strong>{{ t.title }}</strong>
                                    <p>{{ t.training_date }}<span v-if="t.location"> — {{ t.location }}</span></p>
                                    <a v-if="t.certificate_file" :href="fileUrl(t.certificate_file)" target="_blank" class="mal-text">സർട്ടിഫിക്കറ്റ് കാണുക</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p class="text-muted text-center mb-0" v-else>ഇതുവരെ ഒന്നും ചേർത്തിട്ടില്ല</p>
                </div>
            </div>

            <!-- EXTERNAL TRAININGS -->
            <div class="section mt-3">
                <div class="wc-section-title">
                    <span class="wc-icon-circle pink"><ion-icon name="ribbon-outline"></ion-icon></span>
                    <span class="mal-text">പുറത്തുനിന്നുള്ള സർട്ടിഫിക്കറ്റുകൾ (External Certifications & Training)</span>
                </div>
                <div class="wc-card wc-card-pink">
                    <div class="transactions" v-if="profile.external_trainings.length">
                        <div class="item" v-for="t in profile.external_trainings" :key="'et' + t.id">
                            <div class="detail">
                                <div>
                                    <strong>{{ t.title }}</strong>
                                    <p>{{ t.issuing_agency }}<span v-if="t.training_date"> — {{ t.training_date }}</span></p>
                                    <a v-if="t.certificate_file" :href="fileUrl(t.certificate_file)" target="_blank" class="mal-text">സർട്ടിഫിക്കറ്റ് കാണുക</a>
                                </div>
                            </div>
                            <button type="button" class="btn btn-outline-danger btn-sm" @click="deleteExternalTraining(t.id)">
                                <ion-icon name="trash-outline"></ion-icon>
                            </button>
                        </div>
                    </div>
                    <p class="text-muted text-center mb-0" v-else>ഇതുവരെ ഒന്നും ചേർത്തിട്ടില്ല</p>

                    <div class="wc-card-divider" v-if="!showAddExternalTraining">
                        <button type="button" class="btn btn-outline-primary btn-block wc-btn-icon mal-text" @click="showAddExternalTraining = true">
                            <ion-icon name="add-circle-outline"></ion-icon>
                            <span>സർട്ടിഫിക്കറ്റ് ചേർക്കുക</span>
                        </button>
                    </div>
                    <div class="wc-card-divider" v-else>
                        <Form @submit="submitExternalTraining" :validation-schema="externalTrainingSchema">
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label mal-text text-primary">ട്രെയിനിംഗ് പേര് <span class="text-danger">*</span></label>
                                    <Field type="text" name="title" class="form-control" v-model="newExternalTraining.title" />
                                    <ErrorMessage name="title" class="error-feedback" />
                                </div>
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label mal-text text-primary">നൽകിയ ഏജൻസി <span class="text-danger">*</span></label>
                                    <Field type="text" name="issuing_agency" class="form-control" v-model="newExternalTraining.issuing_agency" />
                                    <ErrorMessage name="issuing_agency" class="error-feedback" />
                                </div>
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label mal-text text-primary">തീയതി</label>
                                    <Field type="date" name="training_date" class="form-control" v-model="newExternalTraining.training_date" />
                                </div>
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label mal-text text-primary">സർട്ടിഫിക്കറ്റ് നമ്പർ</label>
                                    <Field type="text" name="certificate_number" class="form-control" v-model="newExternalTraining.certificate_number" />
                                </div>
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label mal-text text-primary">സർട്ടിഫിക്കറ്റ്</label>
                                    <input type="file" class="form-control" accept=".pdf,.jpg,.jpeg,.png" @change="onExternalFileChange">
                                </div>
                            </div>
                            <button type="submit" class="btn btn-primary btn-block" :disabled="savingExternalTraining">
                                <span v-show="savingExternalTraining" class="spinner-border spinner-border-sm"></span>
                                <span class="mal-text">ചേർക്കുക (Add)</span>
                            </button>
                            <button type="button" class="btn btn-block btn-outline-secondary mt-2 wc-btn-icon mal-text" @click="showAddExternalTraining = false">
                                <ion-icon name="arrow-back-outline"></ion-icon>
                                <span>ബാക്ക് (Back)</span>
                            </button>
                        </Form>
                    </div>
                </div>
            </div>

            <!-- QUESTIONNAIRE ANSWERS (read-only) — collapsed by default, it's long. -->
            <div class="section mt-3" v-if="profile.answers && profile.answers.length">
                <div class="wc-section-title wc-collapsible-header" @click="showAdditionalDetails = !showAdditionalDetails">
                    <span class="wc-icon-circle indigo"><ion-icon name="document-text-outline"></ion-icon></span>
                    <span class="mal-text">കൂടുതൽ വിവരങ്ങൾ (Additional Details)</span>
                    <ion-icon name="chevron-down-outline" class="wc-collapse-chevron" :class="{ open: showAdditionalDetails }"></ion-icon>
                </div>
                <transition name="wc-collapse">
                    <div v-show="showAdditionalDetails">
                        <template v-for="(answers, section) in answersBySection" :key="'ans_sec_' + section">
                            <div class="wc-card wc-card-indigo mb-2">
                                <h5 class="mal-text wc-subheading">{{ section }}</h5>
                                <div class="wc-qa-list">
                                    <div class="wc-qa-item" v-for="a in answers" :key="'ans_' + a.question_id">
                                        <p class="wc-qa-question mal-text">{{ questionLabel(a) }}</p>
                                        <p class="wc-qa-answer mal-text">
                                            <template v-if="a.answer_options && a.answer_options.length">{{ a.answer_options.map((o) => resolveOptionLabel(o, a.options)).join(', ') }}</template>
                                            <template v-else>{{ resolveOptionLabel(a.answer_text, a.options) }}</template>
                                            <template v-if="a.other_text"> ({{ a.other_text }})</template>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </transition>
            </div>

            <div class="section mt-3 mb-2">
                <button type="button" class="btn btn-primary btn-block wc-btn-icon mal-text" @click="startEditProfile">
                    <ion-icon name="create-outline"></ion-icon>
                    <span>പ്രൊഫൈൽ എഡിറ്റ് ചെയ്യുക (Edit Profile)</span>
                </button>
            </div>

        </template>

        <!-- PROFILE EDIT -->
        <div class="section pt-0 mt-1 pb-2" v-else>
            <div class="card">
                <div class="card-body">
                    <Form @submit="submitEditProfile" :validation-schema="registerSchema">
                        <!-- DYNAMIC QUESTIONNAIRE -->
                        <template v-for="(qs, section) in questionsBySection" :key="'esec_' + section">
                            <div class="listed-detail mt-1 mb-1">
                                <h4 class="mal-text">{{ section }}</h4>
                            </div>
                            <div class="form-group basic" v-for="q in qs" :key="'eq_' + q.id">
                                <div class="input-wrapper">
                                    <label class="label mal-text text-primary">{{ questionLabel(q) }}<span v-if="q.required" class="text-danger"> *</span></label>

                                    <input v-if="q.type === 'short_text'" type="text" class="form-control" v-model="editAnswerFormData[q.id].answer_text" />

                                    <template v-else-if="q.type === 'single_choice'">
                                        <div class="form-check mb-1" v-for="opt in q.options" :key="'eq_' + q.id + '_' + opt.mal">
                                            <input type="radio" class="form-check-input" :id="'eq_' + q.id + '_' + opt.mal" :name="'eq_' + q.id" :value="opt.mal" v-model="editAnswerFormData[q.id].answer_text" />
                                            <label class="form-check-label mal-text" :for="'eq_' + q.id + '_' + opt.mal">{{ optionLabel(opt) }}</label>
                                        </div>
                                        <div class="form-check mb-1" v-if="q.allow_other">
                                            <input type="radio" class="form-check-input" :id="'eq_' + q.id + '_other'" :name="'eq_' + q.id" value="__other__" v-model="editAnswerFormData[q.id].answer_text" />
                                            <label class="form-check-label mal-text" :for="'eq_' + q.id + '_other'">{{ otherLabel() }}</label>
                                            <input v-if="editAnswerFormData[q.id].answer_text === '__other__'" type="text" class="form-control mt-1" placeholder="വിശദമാക്കുക" v-model="editAnswerFormData[q.id].other_text" />
                                        </div>
                                    </template>

                                    <template v-else-if="q.type === 'checkboxes'">
                                        <div class="form-check mb-1" v-for="opt in q.options" :key="'eq_' + q.id + '_' + opt.mal">
                                            <input type="checkbox" class="form-check-input" :id="'eq_' + q.id + '_' + opt.mal" :value="opt.mal" v-model="editAnswerFormData[q.id].answer_options" />
                                            <label class="form-check-label mal-text" :for="'eq_' + q.id + '_' + opt.mal">{{ optionLabel(opt) }}</label>
                                        </div>
                                        <div class="form-check mb-1" v-if="q.allow_other">
                                            <input type="checkbox" class="form-check-input" :id="'eq_' + q.id + '_other'" value="__other__" v-model="editAnswerFormData[q.id].answer_options" />
                                            <label class="form-check-label mal-text" :for="'eq_' + q.id + '_other'">{{ otherLabel() }}</label>
                                            <input v-if="editAnswerFormData[q.id].answer_options.includes('__other__')" type="text" class="form-control mt-1" placeholder="വിശദമാക്കുക" v-model="editAnswerFormData[q.id].other_text" />
                                        </div>
                                    </template>
                                </div>
                            </div>

                            <template v-if="section === firstQuestionSection">
                                <div class="form-group basic">
                                    <div class="input-wrapper">
                                        <label class="label mal-text text-primary"><ion-icon name="male-female-outline" class="wc-label-icon"></ion-icon>ലിംഗം (Gender)</label>
                                        <Field as="select" name="gender" class="form-control" v-model="editFormData.gender">
                                            <option value="">Select Gender</option>
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                        </Field>
                                    </div>
                                </div>
                                <div class="form-group basic">
                                    <div class="input-wrapper">
                                        <label class="label mal-text text-primary"><ion-icon name="calendar-outline" class="wc-label-icon"></ion-icon>ജനന തീയതി (DOB)</label>
                                        <Field type="date" name="dob" class="form-control" v-model="editFormData.dob" />
                                    </div>
                                </div>
                                <div class="form-group basic">
                                    <div class="input-wrapper">
                                        <label class="label mal-text text-primary"><ion-icon name="mail-outline" class="wc-label-icon"></ion-icon>ഇമെയിൽ (Email)</label>
                                        <Field type="email" name="email" class="form-control" v-model="editFormData.email" />
                                        <ErrorMessage name="email" class="error-feedback" />
                                    </div>
                                </div>
                                <div class="form-group basic">
                                    <div class="input-wrapper">
                                        <label class="label mal-text text-primary"><ion-icon name="home-outline" class="wc-label-icon"></ion-icon>വിലാസം (Address)</label>
                                        <Field as="textarea" name="address" class="form-control" rows="2" v-model="editFormData.address" />
                                    </div>
                                </div>
                            </template>
                        </template>

                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="label mal-text text-primary">എനിക്ക് താഴെപ്പറയുന്ന മേഖലകളിൽ കുഴപ്പമില്ലാത്ത കഴിവ്/അനുഭവങ്ങൾ ഉണ്ട്</label>
                                <div class="form-check mb-1 col-12" v-for="c in serviceCategories" :key="c.id">
                                    <input type="checkbox" class="form-check-input" :id="'ec_sc_' + c.id" :value="c.id" v-model="editFormData.service_category_ids" />
                                    <label class="form-check-label mal-text" :for="'ec_sc_' + c.id">{{ c.name }}<template v-if="c.name_mal"> ({{ c.name_mal }})</template></label>
                                </div>
                            </div>
                        </div>

                        <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="savingProfile">
                            <span v-show="savingProfile" class="spinner-border spinner-border-sm"></span>
                            <span class="mal-text">സേവ് ചെയ്യുക (Save)</span>
                        </button>
                        <button type="button" class="btn btn-block btn-outline-secondary mt-2 wc-btn-icon mal-text" @click="editingProfile = false">
                            <ion-icon name="arrow-back-outline"></ion-icon>
                            <span>ബാക്ക് (Back)</span>
                        </button>
                    </Form>
                </div>
            </div>
        </div>
    </template>

    <!-- Remove Custom Skill confirmation — bottom action-sheet, replacing the native
         window.confirm() popup with the app's usual modal style. -->
    <div class="modal fade action-sheet" id="removeSkillConfirmModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mal-text">മേഖല നീക്കം ചെയ്യുക</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <p class="mal-text text-center mb-3">"{{ pendingRemoveSkill }}" നീക്കം ചെയ്യണോ?</p>
                        <button type="button" class="btn btn-danger btn-block" :disabled="removingSkill" @click="confirmRemoveCustomSkill">
                            <span v-show="removingSkill" class="spinner-border spinner-border-sm"></span>
                            <span class="mal-text">നീക്കം ചെയ്യുക (Remove)</span>
                        </button>
                        <button type="button" class="btn btn-block btn-outline-secondary mt-2 mal-text" @click="cancelRemoveCustomSkill">
                            റദ്ദാക്കുക (Cancel)
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import UserService from "../services/user.service";
import $ from "jquery";

export default {
    name: "WisdomCare",
    components: { Form, Field, ErrorMessage },
    data() {
        return {
            loading: true,
            profile: null,
            serviceCategories: [],
            questions: [],
            consentGiven: false,
            answerFormData: {},
            editAnswerFormData: {},
            successMessage: "",
            errorMessage: "",
            justRegistered: false,
            justRegisteredTimer: null,
            showAdditionalDetails: false,

            registerSchema: yup.object({
                email: yup.string().email("സാധുവായ ഇമെയിൽ നൽകുക").nullable(),
            }),
            registerFormData: { gender: "", dob: "", email: "", address: "", service_category_ids: [] },
            registering: false,

            editingProfile: false,
            editFormData: { gender: "", dob: "", email: "", address: "", service_category_ids: [] },
            savingProfile: false,

            showAddExternalTraining: false,
            externalTrainingSchema: yup.object({
                title: yup.string().required("ഫിൽ ചെയ്യുക!"),
                issuing_agency: yup.string().required("ഫിൽ ചെയ്യുക!"),
            }),
            newExternalTraining: { title: "", issuing_agency: "", training_date: "", certificate_number: "", certificate_file: null },
            savingExternalTraining: false,

            showAddDeployment: false,
            deploymentSchema: yup.object({
                title: yup.string().required("ഫിൽ ചെയ്യുക!"),
                date_from: yup.string().required("ഫിൽ ചെയ്യുക!"),
            }),
            newDeployment: { title: "", date_from: "", date_to: "", location: "", description: "" },
            savingDeployment: false,

            showAddSkill: false,
            newCustomSkillText: "",
            selectedNewCategoryIds: [],
            savingSkill: false,
            removingSkill: null,
            pendingRemoveSkill: null,

            memberDefaults: {},
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        questionsBySection() {
            const grouped = {};
            this.questions.forEach((q) => {
                if (!grouped[q.section]) grouped[q.section] = [];
                grouped[q.section].push(q);
            });
            return grouped;
        },
        // Catalog service categories the volunteer hasn't already picked — shown as quick-add
        // checkboxes in the Skills/Interests card's "Add" panel, alongside the free-text field.
        availableServiceCategories() {
            if (!this.profile) return this.serviceCategories;
            const selectedIds = new Set(this.profile.service_categories.map((c) => c.id));
            return this.serviceCategories.filter((c) => !selectedIds.has(c.id));
        },
        answersBySection() {
            const grouped = {};
            if (!this.profile || !this.profile.answers) return grouped;
            this.profile.answers.forEach((a) => {
                if (!grouped[a.section]) grouped[a.section] = [];
                grouped[a.section].push(a);
            });
            return grouped;
        },
        firstQuestionSection() {
            const keys = Object.keys(this.questionsBySection);
            return keys.length ? keys[0] : null;
        },
    },
    mounted() {
        this.$root.updateParent("Wisdom Care");
        this.loadServiceCategories();
        this.loadQuestions();
        this.loadProfile();
        this.loadMemberDefaults();
    },
    methods: {
        fileUrl(path) {
            return "https://guide.msoftit.com/storage/" + path;
        },
        flash(message, isError = false) {
            this.successMessage = isError ? "" : message;
            this.errorMessage = isError ? message : "";
            setTimeout(() => { this.successMessage = ""; this.errorMessage = ""; }, 4000);
        },
        // Medal gradient for a badge — the admin-set color (if any) blended into a lighter shade
        // for a shiny embossed look, falling back to a default gold medal when no color is set.
        lightenColor(hex, percent) {
            try {
                const num = parseInt(hex.replace("#", ""), 16);
                const amt = Math.round(2.55 * percent);
                const r = Math.min(255, (num >> 16) + amt);
                const g = Math.min(255, ((num >> 8) & 0x00ff) + amt);
                const b = Math.min(255, (num & 0x0000ff) + amt);
                return `#${(0x1000000 + r * 0x10000 + g * 0x100 + b).toString(16).slice(1)}`;
            } catch (e) {
                return hex;
            }
        },
        badgeMedalStyle(b) {
            if (!b.color) return {};
            return { background: `linear-gradient(135deg, ${this.lightenColor(b.color, 35)}, ${b.color})` };
        },
        loadServiceCategories() {
            UserService.authPostRequest("wisdom-care/categories", {}).then(
                (response) => { this.serviceCategories = response.data.data || []; },
                () => { this.serviceCategories = []; }
            );
        },
        loadProfile() {
            this.loading = true;
            UserService.authPostRequest("wisdom-care/my-profile", {}).then(
                (response) => {
                    this.profile = response.data.data || null;
                    this.loading = false;
                },
                () => {
                    this.profile = null;
                    this.loading = false;
                }
            );
        },
        loadQuestions() {
            UserService.authPostRequest("wisdom-care/questions", {}).then(
                (response) => {
                    this.questions = response.data.data || [];
                    this.answerFormData = this.buildEmptyAnswerData(this.questions);
                },
                () => { this.questions = []; }
            );
        },
        loadMemberDefaults() {
            UserService.authPostRequest("wisdom-care/member-defaults", {}).then(
                (response) => {
                    this.memberDefaults = response.data.data || {};
                    if (this.memberDefaults.gender) this.registerFormData.gender = this.memberDefaults.gender;
                    if (this.memberDefaults.dob) this.registerFormData.dob = this.memberDefaults.dob;
                    if (this.memberDefaults.email) this.registerFormData.email = this.memberDefaults.email;
                    if (this.memberDefaults.address) this.registerFormData.address = this.memberDefaults.address;
                    this.answerFormData = this.buildEmptyAnswerData(this.questions);
                },
                () => { this.memberDefaults = {}; }
            );
        },
        buildEmptyAnswerData(questions) {
            const data = {};
            questions.forEach((q) => {
                let rawValue = null;
                if (q.prefill_field === "name") rawValue = (this.currentUser && this.currentUser.name) || null;
                else if (q.prefill_field === "mobile") rawValue = (this.currentUser && this.currentUser.phone) || null;
                else if (q.prefill_field) rawValue = this.memberDefaults[q.prefill_field] || null;

                let answerText = "";
                let answerOptions = [];
                if (rawValue) {
                    if (q.type === "short_text") {
                        // Some prefill fields (age, height, weight) come back as numbers from
                        // the backend, not strings — keep answer_text always a string so later
                        // .trim() calls (validateRequiredAnswers etc.) never blow up on it.
                        answerText = String(rawValue);
                    } else {
                        // single_choice/checkboxes — an admin may have swapped a question (e.g. Blood
                        // Group) from free text to fixed options, so match the member's raw value
                        // against the option list instead of assuming it's already one of the option strings.
                        const match = (q.options || []).find((opt) => this.normalizePrefillValue(opt.mal) === this.normalizePrefillValue(rawValue) || this.normalizePrefillValue(opt.en) === this.normalizePrefillValue(rawValue));
                        if (match) {
                            if (q.type === "single_choice") answerText = match.mal;
                            else answerOptions = [match.mal];
                        }
                    }
                }
                data[q.id] = { answer_text: answerText, answer_options: answerOptions, other_text: "" };
            });
            return data;
        },
        normalizePrefillValue(value) {
            return (value || "").toString().trim().toLowerCase().replace(/\s+/g, "");
        },
        questionLabel(q) {
            if (this.$i18n.locale === "en") {
                return q.question_text_en || q.question_text_mal;
            }
            return q.question_text_mal || q.question_text_en;
        },
        optionLabel(opt) {
            if (this.$i18n.locale === "en") {
                return opt.en || opt.mal;
            }
            return opt.mal || opt.en;
        },
        otherLabel() {
            return this.$i18n.locale === "en" ? "Other" : "മറ്റുള്ളവ";
        },
        resolveOptionLabel(value, options) {
            if (value === "__other__") return this.otherLabel();
            const match = (options || []).find((o) => o.mal === value || o.en === value);
            if (match) return this.optionLabel(match);
            return value;
        },
        buildAnswersPayload(answerData) {
            return Object.keys(answerData).map((questionId) => ({
                question_id: Number(questionId),
                answer_text: answerData[questionId].answer_text || null,
                answer_options: answerData[questionId].answer_options && answerData[questionId].answer_options.length ? answerData[questionId].answer_options : null,
                other_text: answerData[questionId].other_text || null,
            }));
        },
        validateRequiredAnswers(answerData) {
            for (const q of this.questions) {
                if (!q.required) continue;
                const a = answerData[q.id] || { answer_text: "", answer_options: [] };
                // answer_text/other_text should always be strings, but coerce defensively —
                // a stray number from a prefill default must never crash .trim() here.
                const hasText = String(a.answer_text || "").trim() !== "";
                const hasOptions = a.answer_options && a.answer_options.length > 0;
                if (!hasText && !hasOptions) {
                    this.flash("ദയവായി ഈ ചോദ്യത്തിന് ഉത്തരം നൽകുക: " + this.questionLabel(q), true);
                    return false;
                }
                const selectedOther = a.answer_text === "__other__" || (a.answer_options && a.answer_options.includes("__other__"));
                if (selectedOther && String(a.other_text || "").trim() === "") {
                    this.flash("ദയവായി വിശദമാക്കുക: " + this.questionLabel(q), true);
                    return false;
                }
            }
            return true;
        },
        submitRegister() {
            if (!this.validateRequiredAnswers(this.answerFormData)) return;
            this.registering = true;
            const payload = { ...this.registerFormData, answers: this.buildAnswersPayload(this.answerFormData) };
            UserService.authPostRequest("wisdom-care/register", payload).then(
                (response) => {
                    this.registering = false;
                    if (response.data.status !== "success") {
                        this.flash(response.data.message || "രജിസ്ട്രേഷൻ പരാജയപ്പെട്ടു.", true);
                        return;
                    }
                    this.profile = response.data.data;
                    // Dedicated success card instead of the plain flash() alert used for other
                    // actions — registration is a one-time milestone, worth calling out clearly.
                    // Scroll to the top of the freshly-rendered profile view so the card is
                    // immediately visible instead of leaving the user wherever the long
                    // questionnaire form happened to be scrolled.
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    this.justRegistered = true;
                    if (this.justRegisteredTimer) clearTimeout(this.justRegisteredTimer);
                    this.justRegisteredTimer = setTimeout(() => { this.justRegistered = false; }, 3000);
                },
                () => {
                    this.registering = false;
                    this.flash("എന്തോ തെറ്റ് സംഭവിച്ചു. ദയവായി വീണ്ടും ശ്രമിക്കുക.", true);
                }
            );
        },
        startEditProfile() {
            this.editFormData = {
                gender: this.profile.gender || this.memberDefaults.gender || "",
                dob: this.profile.dob || this.memberDefaults.dob || "",
                email: this.profile.email || this.memberDefaults.email || "",
                address: this.profile.address || this.memberDefaults.address || "",
                service_category_ids: this.profile.service_categories.map((c) => c.id),
            };
            this.editAnswerFormData = this.buildEmptyAnswerData(this.questions);
            (this.profile.answers || []).forEach((a) => {
                if (this.editAnswerFormData[a.question_id]) {
                    const hasText = String(a.answer_text || "").trim() !== "";
                    const hasOptions = a.answer_options && a.answer_options.length > 0;
                    // A blank saved answer shouldn't blot out the prefilled default that
                    // buildEmptyAnswerData() just set — only real saved content overrides it.
                    if (hasText || hasOptions) {
                        this.editAnswerFormData[a.question_id] = {
                            answer_text: a.answer_text != null ? String(a.answer_text) : "",
                            answer_options: a.answer_options || [],
                            other_text: a.other_text || "",
                        };
                    }
                }
            });
            this.editingProfile = true;
        },
        submitEditProfile() {
            if (!this.validateRequiredAnswers(this.editAnswerFormData)) return;
            this.savingProfile = true;
            const payload = { ...this.editFormData, answers: this.buildAnswersPayload(this.editAnswerFormData) };
            UserService.authPostRequest("wisdom-care/update-profile", payload).then(
                (response) => {
                    this.savingProfile = false;
                    if (response.data.status !== "success") {
                        this.flash(response.data.message || "അപ്ഡേറ്റ് പരാജയപ്പെട്ടു.", true);
                        return;
                    }
                    this.profile = response.data.data;
                    this.editingProfile = false;
                    this.flash("പ്രൊഫൈൽ അപ്ഡേറ്റ് ചെയ്തു.");
                },
                () => {
                    this.savingProfile = false;
                    this.flash("എന്തോ തെറ്റ് സംഭവിച്ചു. ദയവായി വീണ്ടും ശ്രമിക്കുക.", true);
                }
            );
        },
        onExternalFileChange(e) {
            this.newExternalTraining.certificate_file = e.target.files[0] || null;
        },
        submitExternalTraining() {
            this.savingExternalTraining = true;
            const formData_ = new FormData();
            Object.keys(this.newExternalTraining).forEach((key) => {
                if (key === "certificate_file") {
                    if (this.newExternalTraining.certificate_file) formData_.append("certificate_file", this.newExternalTraining.certificate_file);
                } else if (this.newExternalTraining[key]) {
                    formData_.append(key, this.newExternalTraining[key]);
                }
            });
            UserService.authPostRequest("wisdom-care/external-trainings/add", formData_).then(
                (response) => {
                    this.savingExternalTraining = false;
                    if (response.data.status !== "success") {
                        this.flash(response.data.message || "ചേർക്കാൻ കഴിഞ്ഞില്ല.", true);
                        return;
                    }
                    this.newExternalTraining = { title: "", issuing_agency: "", training_date: "", certificate_number: "", certificate_file: null };
                    this.showAddExternalTraining = false;
                    this.loadProfile();
                    this.flash("സർട്ടിഫിക്കറ്റ് ചേർത്തു.");
                },
                () => {
                    this.savingExternalTraining = false;
                    this.flash("എന്തോ തെറ്റ് സംഭവിച്ചു. ദയവായി വീണ്ടും ശ്രമിക്കുക.", true);
                }
            );
        },
        deleteExternalTraining(trainingId) {
            UserService.authPostRequest("wisdom-care/external-trainings/delete", { training_id: trainingId }).then(
                (response) => {
                    if (response.data.status === "success") this.loadProfile();
                },
                () => { this.flash("നീക്കം ചെയ്യാൻ കഴിഞ്ഞില്ല.", true); }
            );
        },
        submitDeployment() {
            this.savingDeployment = true;
            UserService.authPostRequest("wisdom-care/deployments/add", this.newDeployment).then(
                (response) => {
                    this.savingDeployment = false;
                    if (response.data.status !== "success") {
                        this.flash(response.data.message || "ചേർക്കാൻ കഴിഞ്ഞില്ല.", true);
                        return;
                    }
                    this.newDeployment = { title: "", date_from: "", date_to: "", location: "", description: "" };
                    this.showAddDeployment = false;
                    this.loadProfile();
                    this.flash("ചേർത്തു.");
                },
                () => {
                    this.savingDeployment = false;
                    this.flash("എന്തോ തെറ്റ് സംഭവിച്ചു. ദയവായി വീണ്ടും ശ്രമിക്കുക.", true);
                }
            );
        },
        deleteDeployment(deploymentId) {
            UserService.authPostRequest("wisdom-care/deployments/delete", { deployment_id: deploymentId }).then(
                (response) => {
                    if (response.data.status === "success") this.loadProfile();
                },
                () => { this.flash("നീക്കം ചെയ്യാൻ കഴിഞ്ഞില്ല.", true); }
            );
        },
        // Handles both quick-add mechanisms in the Skills/Interests "Add" panel: catalog
        // categories checked from the list (update-service-categories, replacing the volunteer's
        // full category set with the previous selection plus whatever's newly checked) and/or a
        // freeform custom skill (add-custom-skill) — either or both may be filled in at once.
        async submitAddCustomSkill() {
            const skillText = this.newCustomSkillText.trim();
            if (!skillText && !this.selectedNewCategoryIds.length) return;
            this.savingSkill = true;
            try {
                if (this.selectedNewCategoryIds.length) {
                    const ids = this.profile.service_categories.map((c) => c.id).concat(this.selectedNewCategoryIds);
                    const catResponse = await UserService.authPostRequest("wisdom-care/update-service-categories", { service_category_ids: ids });
                    if (catResponse.data.status !== "success") {
                        this.flash(catResponse.data.message || "ചേർക്കാൻ കഴിഞ്ഞില്ല.", true);
                        this.savingSkill = false;
                        return;
                    }
                    this.profile = catResponse.data.data;
                }
                if (skillText) {
                    const skillResponse = await UserService.authPostRequest("wisdom-care/add-custom-skill", { skill: skillText });
                    if (skillResponse.data.status !== "success") {
                        this.flash(skillResponse.data.message || "ചേർക്കാൻ കഴിഞ്ഞില്ല.", true);
                        this.savingSkill = false;
                        return;
                    }
                    this.profile = skillResponse.data.data;
                }
                this.savingSkill = false;
                this.newCustomSkillText = "";
                this.selectedNewCategoryIds = [];
                this.showAddSkill = false;
                this.flash("ചേർത്തു.");
            } catch (e) {
                this.savingSkill = false;
                this.flash("എന്തോ തെറ്റ് സംഭവിച്ചു. ദയവായി വീണ്ടും ശ്രമിക്കുക.", true);
            }
        },
        removeCustomSkill(skill) {
            this.pendingRemoveSkill = skill;
            $("#removeSkillConfirmModal").modal("show");
        },
        cancelRemoveCustomSkill() {
            $("#removeSkillConfirmModal").modal("hide");
            this.pendingRemoveSkill = null;
        },
        confirmRemoveCustomSkill() {
            const skill = this.pendingRemoveSkill;
            if (!skill) return;
            this.removingSkill = skill;
            UserService.authPostRequest("wisdom-care/delete-custom-skill", { skill }).then(
                (response) => {
                    this.removingSkill = null;
                    if (response.data.status !== "success") {
                        this.flash(response.data.message || "നീക്കം ചെയ്യാൻ കഴിഞ്ഞില്ല.", true);
                        return;
                    }
                    $("#removeSkillConfirmModal").modal("hide");
                    this.pendingRemoveSkill = null;
                    this.profile = response.data.data;
                    this.flash("നീക്കം ചെയ്തു.");
                },
                () => {
                    this.removingSkill = null;
                    this.flash("എന്തോ തെറ്റ് സംഭവിച്ചു. ദയവായി വീണ്ടും ശ്രമിക്കുക.", true);
                }
            );
        },
    },
};
</script>

<style scoped>
.wc-card {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.09);
    padding: 14px 16px;
}

/* Light pastel tint + colored left accent bar per section — same white card everywhere read
   as visually flat, this gives each section its own identity while staying subtle enough not
   to fight the content. */
.wc-card-blue { background: #eef4ff; border-left: 4px solid #3b5bdb; }
.wc-card-neutral { background: #f5f6f9; border-left: 4px solid #9aa3b5; }
.wc-card-purple { background: #f5f0ff; border-left: 4px solid #8b5cf6; }
.wc-card-green { background: #eafaf1; border-left: 4px solid #12a85a; }
.wc-card-amber { background: #fdf3d8; border-left: 4px solid #f0a416; }
.wc-card-teal { background: #e6faf7; border-left: 4px solid #0d9488; }
.wc-card-pink { background: #fdeef5; border-left: 4px solid #ec4899; }
.wc-card-indigo { background: #eef0ff; border-left: 4px solid #4f46e5; }
.wc-card-orange { background: #fff1e6; border-left: 4px solid #ea580c; }

/* Registration success card — a one-time celebratory moment, auto-dismisses after 3s
   (see justRegistered in submitRegister()), distinct from the plain flash() alert used
   for every other action on this page. */
.wc-success-card {
    background: linear-gradient(135deg, #12a85a, #0d8a49);
    border-radius: 14px;
    padding: 22px 18px;
    text-align: center;
    color: #fff;
    box-shadow: 0 6px 18px rgba(18, 168, 90, 0.35);
}
.wc-success-icon {
    font-size: 44px;
    line-height: 1;
    margin-bottom: 6px;
}
.wc-success-card h4 {
    margin: 0 0 4px;
    font-weight: 800;
}
.wc-success-card p {
    margin: 0;
    opacity: 0.92;
    font-size: 13.5px;
}
.wc-success-pop-enter-active {
    transition: opacity 0.35s ease, transform 0.35s ease;
}
.wc-success-pop-leave-active {
    transition: opacity 0.4s ease, transform 0.4s ease;
}
.wc-success-pop-enter-from {
    opacity: 0;
    transform: scale(0.92) translateY(-8px);
}
.wc-success-pop-leave-to {
    opacity: 0;
    transform: scale(0.96);
}

/* Collapsible "Additional Details" header/chevron. */
.wc-collapsible-header {
    cursor: pointer;
    user-select: none;
    justify-content: space-between;
}
.wc-collapse-chevron {
    font-size: 16px !important;
    color: #6c757d !important;
    transition: transform 0.2s ease;
    margin-left: auto;
}
.wc-collapse-chevron.open {
    transform: rotate(180deg);
}
.wc-collapse-enter-active,
.wc-collapse-leave-active {
    transition: opacity 0.2s ease;
}
.wc-collapse-enter-from,
.wc-collapse-leave-to {
    opacity: 0;
}

/* Verified Skill Badges — list rows (icon + name/subtitle + chevron), matching this card's
   list-item styling elsewhere in the app rather than a medal grid, so it stays compact and
   readable whether there's one badge or several. */
.wc-badge-list-card {
    padding: 4px 12px;
}

.wc-badge-list-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 0;
    border-top: 1px solid rgba(146, 97, 10, 0.12);
}

.wc-badge-list-item:first-child {
    border-top: none;
}

/* Small shiny embossed icon (gold by default, or the admin-set color via badgeMedalStyle())
   so it still reads as an "achievement" rather than a plain flat icon. */
.wc-badge-list-icon {
    flex-shrink: 0;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 19px;
    color: #fff;
    background: linear-gradient(135deg, #ffe08a, #f0a416);
    border: 2px solid #fff8e6;
    box-shadow:
        0 3px 7px rgba(197, 132, 4, 0.4),
        inset 0 -3px 5px rgba(140, 87, 0, 0.35),
        inset 0 2px 4px rgba(255, 255, 255, 0.65);
}

.wc-badge-list-icon ion-icon {
    font-size: 18px;
    filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.25));
}

.wc-badge-list-info {
    flex: 1;
    min-width: 0;
}

.wc-badge-list-name {
    font-size: 14px;
    font-weight: 800;
    color: #27173e;
}

.wc-badge-list-sub {
    font-size: 12px;
    color: #6c757d;
    margin-top: 1px;
}

.wc-badge-list-date {
    font-size: 11px;
    color: #a1793a;
    margin-top: 1px;
}

.wc-badge-list-chevron {
    flex-shrink: 0;
    font-size: 18px;
    color: #d1ad5c;
}

.wc-profile-card {
    padding: 10px 14px;
}

.wc-profile-header {
    display: flex;
    align-items: center;
    gap: 10px;
}

.wc-profile-info {
    flex: 1;
    min-width: 0;
}

.wc-avatar-icon {
    width: 44px;
    height: 44px;
    border-radius: 100%;
    background: #1a418c;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;
    overflow: hidden;
}

.wc-avatar-icon img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.wc-profile-info h3 {
    margin-bottom: 2px;
    font-size: 15px;
}

.wc-profile-info .basic-inline-text {
    font-size: 12px;
}

.wc-status-pill {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    margin-top: 4px;
    padding: 1px 8px;
    border-radius: 100px;
    font-size: 10px;
    font-weight: 700;
}

.wc-status-pill ion-icon {
    font-size: 11px;
}

.wc-status-pill.verified {
    background: #e6f7ec;
    color: #15803d;
}

.wc-status-pill.not-verified {
    background: #fdecea;
    color: #c0392b;
}

.wc-section-title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    padding: 0 2px;
}

.wc-section-title ion-icon {
    font-size: 18px;
    color: #1a418c;
    flex-shrink: 0;
}

.wc-section-title span {
    font-size: 15px;
    font-weight: 600;
    color: #27173e;
}

/* Colored icon-circle for section headers — same accent colors as the card backgrounds
   below, so each section reads as one visually consistent unit (icon + card). */
.wc-icon-circle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    flex-shrink: 0;
    color: #fff;
}

.wc-icon-circle ion-icon {
    font-size: 15px;
    color: #fff;
}

.wc-icon-circle.blue { background: #3b5bdb; }
.wc-icon-circle.purple { background: #8b5cf6; }
.wc-icon-circle.green { background: #12a85a; }
.wc-icon-circle.amber { background: #f0a416; }
.wc-icon-circle.teal { background: #0d9488; }
.wc-icon-circle.pink { background: #ec4899; }
.wc-icon-circle.indigo { background: #4f46e5; }
.wc-icon-circle.orange { background: #ea580c; }

.wc-chip {
    display: inline-block;
    background: #eaf1ff;
    color: #1a418c;
    border: 1px solid #d3e2ff;
    border-radius: 999px;
    padding: 5px 12px;
    font-size: 13px;
    font-weight: 500;
    margin: 0 6px 6px 0;
}

.wc-chip-removable {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding-right: 8px;
}

.wc-chip-remove {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border: none;
    border-radius: 50%;
    background: rgba(26, 65, 140, 0.12);
    color: #1a418c;
    font-size: 13px;
    line-height: 1;
    padding: 0;
    cursor: pointer;
}

.wc-chip-remove:disabled {
    opacity: 0.5;
    cursor: default;
}

.wc-hero-logo {
    margin: 0 auto;
    max-width: 220px;
}

.wc-hero-logo img {
    width: 100%;
    height: auto;
    display: block;
}

.wc-label-icon {
    font-size: 15px;
    vertical-align: -2px;
    margin-right: 5px;
    color: #1a418c;
}

.wc-card-divider {
    margin-top: 14px;
    padding-top: 14px;
    border-top: 1px solid #f0f0f5;
}

/* Flatten the list-item component's own card look (background/shadow/margin) once it's
   nested inside .wc-card, so items read as plain divided rows instead of cards-in-a-card. */
.wc-card .transactions .item {
    background: transparent;
    box-shadow: none;
    border-radius: 0;
    padding: 12px 0;
    margin-bottom: 0;
    border-bottom: 1px solid #f0f0f5;
}

.wc-card .transactions .item:first-child {
    padding-top: 0;
}

.wc-card .transactions .item:last-child {
    padding-bottom: 0;
    border-bottom: none;
}

.wc-subheading {
    font-size: 14.5px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: #6c757d;
    margin-bottom: 10px;
}

/* Icon + text detail row, matches the pattern used in callFollowUpFormV2.vue */
.basic-inline {
    display: flex;
    align-items: center;
    gap: 6px;
}

.basic-inline-icon {
    font-size: 16px;
    color: #1a418c;
    flex-shrink: 0;
}

.basic-inline-text {
    font-size: 14px;
    color: #495057;
    word-break: break-word;
}

.basic-inline-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 12px;
    row-gap: 10px;
}

.basic-inline-full {
    grid-column: 1 / -1;
}

.form-group-compact {
    margin-bottom: 0;
}

/* Stacked question/answer rows — reads better than a side-by-side listview once
   either the question or the answer is a full sentence that wraps on mobile. */
.wc-qa-item {
    padding: 12px 0;
    border-bottom: 1px solid #f0f0f5;
}

.wc-qa-item:first-child {
    padding-top: 0;
}

.wc-qa-item:last-child {
    padding-bottom: 0;
    border-bottom: none;
}

.wc-qa-question {
    font-size: 14px;
    color: #8a8a8f;
    margin-bottom: 4px;
}

.wc-qa-answer {
    font-size: 16.5px;
    color: #27173e;
    font-weight: 500;
    margin-bottom: 0;
    line-height: 1.4;
}

.wc-btn-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.wc-btn-icon ion-icon {
    font-size: 19px;
    flex-shrink: 0;
}

/* Keep the checkbox/radio aligned with the first line of the label even when a long
   option (e.g. the rescue-skills checklist) wraps to multiple lines on mobile. */
.form-check {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding-left: 0;
}

.form-check-input {
    margin-top: 3px;
    flex-shrink: 0;
}

.form-check-label {
    flex: 1;
}
</style>
